import { Canvas } from "@react-three/fiber";
import * as THREE from "three";
import { Suspense } from "react";
import Track3D from "./Track3D";
import Cart from "./Cart";
import Environment3D from "./Environment3D";
import GameLoop from "./GameLoop";
import HUD from "./HUD";
import StartMenu from "./StartMenu";
import RecapModal from "./RecapModal";
import FinishScreen from "./FinishScreen";
import DecisionPause from "./DecisionPause";
import ConsequenceModal from "./ConsequenceModal";
import LiveGraphs from "./LiveGraphs";
import TouchControls from "./TouchControls";
import ExamMode from "./ExamMode";
import PhysicsLab from "./PhysicsLab";
import ChallengeSelect from "./ChallengeSelect";
import ChallengeSplash from "./ChallengeSplash";
import ParkMap from "./ParkMap";
import Sparks from "./Sparks";
import { useGame, MODES } from "./store";
import { initAudio, stopAll } from "./sound";
import { useEffect } from "react";

export default function PhysicsCoasterGame() {
  const mode = useGame((s) => s.mode);
  const screen = useGame((s) => s.screen);
  const showMenu = mode === MODES.MENU;
  const showRecap = mode === MODES.RECAP;
  const showFinish = mode === MODES.FINISHED;
  const challengeGoal = useGame((s) => s.challengeGoal);
  const showChallengeSelect = useGame((s) => s.showChallengeSelect);

  const hideHUD = showMenu || showFinish;

  useEffect(() => {
    return () => stopAll();
  }, []);
  useEffect(() => {
    if (mode === MODES.MENU || mode === MODES.FINISHED) stopAll();
  }, [mode]);

  return (
    <div
      data-testid="game-root"
      onPointerDown={() => initAudio()}
      onKeyDown={() => initAudio()}
      style={{
        position: "relative",
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
        background: "#02030a",
      }}
    >
      {/* 3D Canvas — always mounted */}
      <Canvas
        shadows
        camera={{ position: [0, 8, -18], fov: 70, near: 0.1, far: 1200 }}
        gl={{ antialias: true, powerPreference: "high-performance", shadowMapType: THREE.PCFSoftShadowMap }}
      >
        <Suspense fallback={null}>
          <Environment3D />
          <Track3D />
          <Cart />
          <Sparks />
          <GameLoop />
        </Suspense>
      </Canvas>

      {/* UI overlays */}
      {!hideHUD && <HUD />}
      {!hideHUD && !showRecap && <LiveGraphs />}
      {!hideHUD && !showRecap && <DecisionPause />}
      {!hideHUD && !showRecap && <TouchControls />}
      {!hideHUD && <ConsequenceModal />}
      {showMenu && <StartMenu />}
      {showRecap && <RecapModal />}
      {showFinish && (challengeGoal ? <ChallengeSplash /> : <FinishScreen />)}

      {/* App-level screens (above everything) */}
      {screen === "map" && <ParkMap />}
      {screen === "exam" && <ExamMode />}
      {screen === "lab" && <PhysicsLab />}
      {showChallengeSelect && <ChallengeSelect />}
    </div>
  );
}
